import { render, staticRenderFns } from "./quick-contact.vue?vue&type=template&id=58bf4385&"
import script from "./quick-contact.vue?vue&type=script&lang=js&"
export * from "./quick-contact.vue?vue&type=script&lang=js&"
import style0 from "./quick-contact.vue?vue&type=style&index=0&id=58bf4385&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports